module.exports = __webpack_public_path__ + "img/product-preview-38.2aac2e7.png";